import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';
import {mode} from '@chakra-ui/theme-tools';

import {tokens as dark} from '../../generated/dark';
import {tokens as light} from '../../generated/light';

import {anatomy} from './anatomy';
import {vars} from './vars';

export const {defineMultiStyleConfig, definePartsStyle} = createMultiStyleConfigHelpers(anatomy.keys());

/**
 * Recharts doesn't works with styled system so we use CSS variables to style the chart
 */
export const barChartStyleConfig = defineMultiStyleConfig({
  baseStyle: {
    container: {
      [vars.fill.variable]: mode(
        `colors.${light.components.charts.neutral.default}`,
        `colors.${dark.components.charts.neutral.default}`,
      ),

      width: `100%`,
      alignSelf: `stretch`,
    },
  },
});
